import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
let store = new Vuex.Store({
  state: {
    // token: '1fe4af0c39a1e8d4c5404982b600f77e',
    token: '',
    jsdata: [],
    isplak: false,
    filtearr: [],
    Instruction: ''
  },
  mutations: {
    GETJSDATA(state, payload) {
      state.jsdata = payload;
    },
    PLAK(state, payload) {
      state.isplak = payload;
    },
    FILTEARR(state, payload) {
      state.filtearr = payload;
    },
    GETlongitude(state, payload) {
      state.Instruction = payload;
    }
  },
  actions: {
    filteArr({ commit }, ARR) {
      commit('FILTEARR', ARR);
    }
  }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js